export enum SectionDataType {
  ChannelStores = 'ChannelStores',
  InfoPanel = 'InfoPanel',
  Shortcut = 'Shortcut',
  OrderHistory = 'OrderHistory',
  StoreProducts = 'StoreProducts',
  SplashCarousell = 'SplashCarousell'
}

